import { useCallback } from "react";
import { Control } from "react-hook-form";
import { useIntl } from "react-intl";
import { KeyValue } from "../../../models/key-value";
import SelectFormInput from "../../Shared/SelectInput/SelectFormInput";
import infoService from "../../../services/info.service";
import { IntlReportTypes, ReportTypes, ReportTypesResponse } from "../../../models/reports.interface";
import useAsyncSelectFormInput from "../../../hooks/useAsyncSelectFormInput";

interface IReportTypeFormInput {
  type: string;
}

type ReportTypeSelectFormInputProps = {
  control: Control<IReportTypeFormInput, object>;
  required?: boolean;
  disabled?: boolean;
  isInvalid?: boolean;
  setDefaultReportType: (value: string) => void;
};

const ReportTypesSelectFormInput = ({
  isInvalid,
  disabled,
  control,
  required = false,
  setDefaultReportType,
}: ReportTypeSelectFormInputProps) => {
  const intl = useIntl();

  const loadingPlaceholder = intl.messages["GLOBAL.LOADING"] as string;
  const loadItems = useCallback(async (): Promise<KeyValue<string>[]> => {
    const { data } = await infoService.getReportTypes();
    const mappedTypes: ReportTypesResponse[] = [];

    if (data) {
      data.forEach((item: ReportTypes) => {
        if (!item) return;
        mappedTypes.push({
          key: item,
          value: intl.messages[IntlReportTypes[item]] as string,
        });
      });
    }

    if (mappedTypes?.length) {
      const defaultSelected =
        mappedTypes.find((i) => i?.key === ReportTypes.EcgList) ||
        mappedTypes[0];
      setDefaultReportType(defaultSelected.key ?? null);
    }

    return mappedTypes ?? null;
  }, [intl.messages, setDefaultReportType]);

  const { selectItems, selectPlaceholder } = useAsyncSelectFormInput(
    loadItems,
    loadingPlaceholder
  );

  return (
    <SelectFormInput
      name={"type"}
      control={control}
      rules={{
        required: required,
      }}
      input={{
        items: selectItems,
        disabled: disabled,
        readOnly: disabled,
        isInvalid: isInvalid,
        placeholder: selectPlaceholder,
      }}
    />
  );
};
export default ReportTypesSelectFormInput;
